/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GlobalConfigurationDto } from '../../models/global-configuration-dto';

export interface GetGlobalConfiguration$Params {
  id: string;
}

export function getGlobalConfiguration(http: HttpClient, rootUrl: string, params: GetGlobalConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalConfigurationDto>> {
  const rb = new RequestBuilder(rootUrl, getGlobalConfiguration.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GlobalConfigurationDto>;
    })
  );
}

getGlobalConfiguration.PATH = '/v0/globalConfigurations/{id}';
